import { render, staticRenderFns } from "./dinamis-form.vue?vue&type=template&id=ee2eac52&scoped=true&"
import script from "./dinamis-form.vue?vue&type=script&lang=js&"
export * from "./dinamis-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2eac52",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CBox: require('@chakra-ui/vue').CBox})
